import type { RoutineInput } from '@fitness/api-client';
import { Link, createFileRoute, useNavigate } from '@tanstack/react-router';
import { ArrowLeft } from 'lucide-react';

import { PageHeader } from '@/components/PageHeader';
import { RoutineEditor } from '@/components/routine/RoutineEditor';
import { describeError } from '@/lib/api';
import { SAVED, showToast } from '@/lib/toast';
import { useCreateRoutine } from '@/lib/queries/routines';

export const Route = createFileRoute('/_app/routines/new')({
  component: NewRoutinePage,
});

function NewRoutinePage() {
  const navigate = useNavigate();
  const create = useCreateRoutine();

  function handleSave(input: RoutineInput): void {
    create.mutate(input, {
      onSuccess: (routine) => {
        showToast(SAVED.routineCreated);
        void navigate({ to: '/routines/$id', params: { id: routine.id } });
      },
    });
  }

  return (
    <>
      <PageHeader
        title="Nueva rutina"
        subtitle="Ponle nombre, añade los días y elige los ejercicios."
        action={
          <Link
            to="/routines"
            search={{ archived: false }}
            aria-label="Volver a mis rutinas"
            className="flex size-11 items-center justify-center rounded-xl border border-line text-ink-muted transition-colors hover:bg-surface-raised"
          >
            <ArrowLeft className="size-5" aria-hidden="true" />
          </Link>
        }
      />

      <RoutineEditor
        onSave={handleSave}
        saving={create.isPending}
        errorMessage={create.isError ? describeError(create.error, { saving: true }) : undefined}
        submitLabel="Crear rutina"
        onCancel={() => void navigate({ to: '/routines', search: { archived: false } })}
      />
    </>
  );
}
